module.exports = __webpack_public_path__ + "media/audio10.5197dd58.wav";